import { Box, Button, Typography } from "@mui/material";
import { t } from "i18next";
import {
  ArrowBackIcon,
  DriveFileRenameOutlineIcon,
} from "../../icons/index.tsx";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CustomMuiButton } from "../../utils/styleUtils.js";
import {
  createAIServer,
  getAIServerDetail,
  updateAIServer,
} from "../../services/serverRuleService.js";
import { toast } from "react-toastify";
import "../../index.css";

export default function SererFormPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    serverAddress: "",
    identifier: "",
    gpu: "",
    tag: "",
  });

  useEffect(() => {
    if (!id) return;
    const fetchData = async () => {
      try {
        const response = await getAIServerDetail(id);
        setFormData({
          serverAddress: response.serverAddress || "",
          identifier: response.identifier || "",
          gpu: response.gpu || "",
          tag: response.tag || "",
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [id]);

  const updateFormData = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleBackClick = () => {
    navigate("/home", { state: { tab: "server_manage" } });
  };

  const handleSubmit = async () => {
    // return;
    try {
      const updateData = {
        id: id,
        serverAddress: formData.serverAddress,
        identifier: formData.identifier,
        gpu: formData.gpu,
        tag: formData.tag,
      };
      if (id) {
        await updateAIServer(updateData);
        toast.success("서버 업데이트가 완료되었습니다.");
      } else {
        await createAIServer(updateData);
        toast.success("서버 생성이 완료되었습니다.");
      }
      navigate("/home", { state: { tab: "server_manage" } });
    } catch (error) {
      console.error("Submit failed:", error);
      // 에러 처리 로직 추가
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        width: "100%",
        p: 3,
      }}
    >
      <Box sx={{ display: "flex" }}>
        <Button
          className="add-button"
          onClick={handleBackClick}
          sx={{ color: "var(--button-color)" }}
        >
          <ArrowBackIcon /> <span>{t("ServerManage")}</span>
        </Button>
      </Box>
      <Box sx={{ height: "100%", width: "100%", marginTop: 3 }}>
        <Typography
          sx={{
            mb: 1,
            fontWeight: "700",
            fontSize: 24,
            display: "flex",
            alignItems: "center",
          }}
          fontFamily={"NotoSansKR-Variable"}
        >
          <DriveFileRenameOutlineIcon sx={{ marginRight: "5px" }} />
          {id ? t("ServerManage") : t("CreateServer")}
        </Typography>
        <div className="input-container">
          <input
            type="text"
            className="input-field"
            placeholder="내용을 입력하세요"
            value={formData.serverAddress}
            onChange={(e) => updateFormData("serverAddress", e.target.value)}
          />
          <label htmlFor="input-field">Server Address</label>
        </div>
        <div className="input-container">
          <input
            type="text"
            id="input-field"
            placeholder="내용을 입력하세요"
            value={formData.identifier}
            onChange={(e) => updateFormData("identifier", e.target.value)}
          />
          <label htmlFor="input-field">Identifier</label>
        </div>
        <div className="input-container">
          <input
            type="text"
            id="input-field"
            placeholder="내용을 입력하세요"
            value={formData.gpu}
            onChange={(e) => updateFormData("gpu", e.target.value)}
          />
          <label htmlFor="input-field">GPU</label>
        </div>
        <div className="input-container">
          <input
            type="text"
            id="input-field"
            placeholder="내용을 입력하세요"
            value={formData.tag}
            onChange={(e) => updateFormData("tag", e.target.value)}
          />
          <label htmlFor="input-field">Tag</label>
        </div>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          marginTop: 3,
        }}
      >
        <>
          <CustomMuiButton
            onClick={handleBackClick}
            variant="text"
            label={t("Cancel")}
          />
          <CustomMuiButton
            onClick={handleSubmit}
            variant="contained"
            label={t("Apply")}
          />
        </>
      </Box>
    </Box>
  );
}
